import axios from "axios";
import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useParams } from "react-router-dom";
import PageLoader from "../../components/global/loader/PageLoader";
import { InternalBanner } from "../../components/internals/InternalBanner";
import './styles.scss';
import ImgFormAvatar from './../../assets/img_form_avatar.png';

export const SidebarPage = ({
    parent_slug
}) => {
    const { slug } = useParams();
    const [pageContent, setPageContent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);

    const [isSucceed, setIsSucceed] = useState(false);
    const [fullName, setFullName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    useEffect(() => {
        document.title = "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
        fetchPageContet(slug);
    }, [slug]);

    
    const fetchPageContet = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(
                parent_slug ? `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${parent_slug}/${slug}` :   `/wp-admin/admin-ajax.php?action=get_pages_by_slug&page_slug=${slug}`);
            var data0 = data
            console.log("ddd", data)

            if (data?.page) {
                if (data?.yoast_title?.length > 0) {
                    document.title = data?.yoast_title;
                } else {
                    document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
                }
                
                if (document.querySelector('#wp-admin-bar-edit a')) {
                    document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                    document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
                }
            }

            setPageContent(data?.page ?? null);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    useEffect(() => {
        document.getElementById('phone')?.addEventListener('input', function (e) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            setPhone(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
        });
    }, []);

    const onSubmitForm = async (e) => {

        e.preventDefault();
        setIsSubmitting(true);

        try {
            await axios.post(
                '/wp-json/gf/v2/forms/1/submissions', // Replace {form_id} with your actual Gravity Form ID
                {
                    'input_1': fullName,
                    'input_3': email,
                    'input_4': phone,
                    'input_5': message,
                    'input_6': window.location.href,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
            );
            // if (window.location.href?.includes("/es/")) {
            //     NotificationManager.success('¡El formulario se ha enviado correctamente!', '¡Éxito!');
            // } else {
            //     NotificationManager.success('Form has been submitted successfully!', 'Success!');
            // }
            setFullName('');
            setPhone('');
            setEmail('');
            setMessage('');
            setIsSucceed(true);
        } catch (err) {
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
        return false;
    }

    return <Fade delay={1}>
        <main id='main' className="internal-page">
            {
                !isFetching && <>    
                    <InternalBanner page={pageContent} />
                    <section id="main-article-content">               
                        <div className="container">
                            <div className="sidebar-inner-wrapper">
                                <article dangerouslySetInnerHTML={{__html: pageContent?.post_content }}></article>
                                <aside sidebar="sidebar">
                                    <div className='form-wrapper'>
                                        <div className='form-heading'>
                                            <span className='form-title'>Get a free Consultation.</span>
                                            <img src={ImgFormAvatar} />
                                            <span className='form-description'>
                                                Hi, this is Joe, founder of JTM Jr. & Associates.
                                                We would love to connect and provide a free consultation
                                            </span>
                                            {
                                                isSucceed && <span className='succeed'>Form submitted successfully!</span>
                                            }
                                        </div>
                                        <form id="banner-form" onSubmit={onSubmitForm}>
                                            <div className='form-fields'>
                                                <input 
                                                    type="text" 
                                                    name='name' 
                                                    id="name" 
                                                    placeholder='Name' 
                                                    required
                                                    value={fullName}
                                                    onChange={(e) => {
                                                        setFullName(e?.target?.value ?? "")
                                                    }}
                                                />
                                                <input 
                                                    type="text" 
                                                    name='phone' 
                                                    id="phone" 
                                                    placeholder='Phone' 
                                                    required
                                                    value={phone}
                                                    onChange={(e) => {
                                                        setPhone(e?.target?.value ?? "")
                                                    }}
                                                />
                                                <input 
                                                    type="email" 
                                                    name='email' 
                                                    id="email" 
                                                    placeholder='Email' 
                                                    required 
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e?.target?.value ?? "")
                                                    }}
                                                />
                                                <textarea 
                                                    name="message" 
                                                    id="message" 
                                                    placeholder='Tell us about your case'
                                                    value={message}
                                                    onChange={(e)=>{
                                                        setMessage(e?.target?.value ?? "")
                                                    }}
                                                />
                                            </div>
                                            <button type="submit" className={`button ${isSubmitting ? 'disabled' : ''}`}>
                                                { isSubmitting ? 'Submitting...' : 'Make an appointment'}
                                            </button>
                                        </form>
                                    </div>
                                </aside>
                            </div>
                        </div>
                    </section>
                </>
            }

            {
                isFetching && <PageLoader />
            }
        </main>
    </Fade>
}
